const data = {
  id: "data_collection",
  title: "Surveillance & Data Collection",
  intro: "Big brother just got a lot more gear — and it's not just watching you, it's monetizing you. How surveillance and data collection became a revenue stream — documented.",
  tabs: [
    {
      id: "data_collection",
      label: "Data Collection",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "surveillance",
      label: "Surveillance",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
